import { Injectable } from '@angular/core';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import {
  BasePageMetaResolver,
  PageType,
  TranslationService,
  BreadcrumbMeta,
  CmsService,
  ContentPageMetaResolver,
} from '@spartacus/core';
import { combineLatest, Observable, of } from 'rxjs';
import { map, mergeMap, switchMap } from 'rxjs/operators';
import { KBPageMetaService } from '../../feature/kb-page-meta.service';
import { KBLanguageService } from '../kbLanguageService/KbLang-service.service';

@Injectable({
  providedIn: 'root',
})
export class KbContentPageMetaResolver extends ContentPageMetaResolver {
  constructor(
    protected translationService: TranslationService,
    protected activeCartFacade: ActiveCartFacade,
    protected override basePageMetaResolver: BasePageMetaResolver,
    protected pageMetaService: KBPageMetaService,
    protected cmsService: CmsService,
    protected languageService: KBLanguageService
  ) {
    super(basePageMetaResolver);
    this.pageType = PageType.CONTENT_PAGE;
  }

  override resolveBreadcrumbs(): Observable<BreadcrumbMeta[] | any[] | undefined> {
    return this.languageService.getActive().pipe(mergeMap(() => this.resolveContentPageMetaBreadcrumbs()));
  }
  resolveContentPageMetaBreadcrumbs(): Observable<BreadcrumbMeta[] | any[] | undefined> {
    return combineLatest([
      this.customBreadCrumbs$,
      this.translationService.translate('common.breadcrumb_home'),
      this.resolveTitle(),
    ]).pipe(
      map(([customBreadcrumbs, homeLabel, title]) => {
        const breadcrumbs: BreadcrumbMeta[] = [{ label: homeLabel, link: '/' }, ...customBreadcrumbs];
        if (breadcrumbs?.length === 1 || breadcrumbs[breadcrumbs.length - 1].link.length > 0) {
          breadcrumbs.push({ label: title?.split('|').length ? title?.split('|')[0] : title, link: '' });
        }
        return breadcrumbs;
      })
    );
  }

  customBreadCrumbs$: Observable<BreadcrumbMeta[] | any[] | undefined> = this.pageMetaService.customBreadcrumbs$.pipe(
    switchMap((breadcrumbs) => {
      if (breadcrumbs?.length) {
        return combineLatest(
          breadcrumbs?.map((customBreadcrumb) =>
            customBreadcrumb?.name ? this.translationService.translate(customBreadcrumb?.name) : of(null)
          )
        ).pipe(
          map((responses) => {
            const breadcrumbsData: BreadcrumbMeta[] = [];
            responses.map((res, index) => {
              if (res) {
                breadcrumbsData.push({
                  label: res?.trim()?.length && res?.charAt(0) != '[' ? res : breadcrumbs[index].name,
                  link: breadcrumbs[index].url,
                });
              }
            });
            return breadcrumbsData;
          })
        );
      } else {
        return of([]);
      }
    })
  );
}
